module.exports = __webpack_public_path__ + "static/media/plane-green.03455461.svg";